import { faClock, faUser } from "@fortawesome/pro-duotone-svg-icons"
import { faTimes } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Space, Typography } from "antd"
import { useAccountSetup } from "./AccountSetupContext"
import './AccountSetupModal.css'

const { Title, Text } = Typography

export type Props = {
  onExit: () => void
}

const AccountSetupIntroStep = ({ onExit }: Props) => {
  const { dispatch } = useAccountSetup()

  const handleGetStarted = () => {
    dispatch({ type: 'NEXT_STEP' })
  }

  return (
    <div className="account-setup-modal-content">
      <div className="account-setup-progress-bar">
        <div className="account-setup-progress-fill" style={{ width: '0%' }} />
      </div>
      <button
        className="account-setup-exit-button"
        onClick={onExit}
        aria-label="Exit setup"
      >
        <FontAwesomeIcon icon={faTimes} />
      </button>
      <div className="account-setup-modal-left account-setup-intro-content">
        <div className="account-setup-modal-icon">
          <FontAwesomeIcon icon={faUser} size="3x" />
        </div>
        <Title level={3} style={{ marginTop: 24, marginBottom: 16 }}>
          Let's Set Up Your Account
        </Title>
        <Text type="secondary" style={{ fontSize: 14, lineHeight: 1.6 }}>
          We'll guide you through configuring your account so SynkedUP works perfectly for your
          business. This includes your company details, services, divisions, and team members.
        </Text>
        <Space style={{ marginTop: 24 }}>
          <FontAwesomeIcon icon={faClock} />
          <Text type="secondary">
            Approximate completion time – <strong>Less than 15 minutes</strong>
          </Text>
        </Space>
        <Button
          type="primary"
          size="large"
          block
          style={{ marginTop: 32, borderRadius: 24, height: 48 }}
          onClick={handleGetStarted}
        >
          Let's Get Started!
        </Button>
      </div>
      <div className="account-setup-modal-right">
        <img
          src="/images/account-setup/intro.png"
          alt="Landscaper at work"
          className="account-setup-modal-image"
        />
        <div className="account-setup-modal-logo">
          <img src="/images/synkedup-dark.png" alt="SynkedUP" />
        </div>
        <div className="account-setup-modal-marketing">
          <Title level={2} style={{ color: 'white', marginBottom: 0 }}>
            Fast, accurate
          </Title>
          <Title level={2} style={{ color: 'white', marginTop: 8, marginBottom: 0 }}>
            estimates—
          </Title>
          <Title level={2} style={{ color: 'white', marginTop: 8, marginBottom: 0 }}>
            no <span className="highlight-underline">guesswork</span> required
          </Title>
        </div>
      </div>
    </div>
  )
}

export default AccountSetupIntroStep
